import React from "react";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import Errors from "../Errors/Errors";

export default class LastNameSignIn extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      errors: [],
      loading: false,
      confirmation_number: "",
      last_name: "",
    };

    this.onChange = this.onChange.bind(this);
    this.onChangeErrors = this.onChangeErrors.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  render() {
    return (
      <form onSubmit={this.onSubmit} style={{ position: "relative" }}>
        <Errors errors={this.state.errors} />
        {this.renderSignIn()}
        <LoadingSpinner
          backgroundColor="rgba(32,33,46,0.5)"
          size="small"
          show={this.state.loading}
        />
      </form>
    );
  }

  renderSignIn() {
    return (
      <div>
        <div className="form-group">
          <label>{I18n.t("confirmation_number")}</label>
          <input
            type="text"
            name="confirmation_number"
            className="form-control"
            value={this.state.confirmation_number}
            onChange={this.onChange}
          />
        </div>

        <div className="form-group">
          <label>{I18n.t("last_name")}</label>
          <input
            type="text"
            name="last_name"
            className="form-control"
            value={this.state.last_name}
            onChange={this.onChange}
          />
        </div>

        <div className="actions">
          <button type="submit" className="btn btn-block btn-primary">
            {I18n.t("find_it")}
          </button>
        </div>
    </div>
    )
  }

  onChange(e) {
    var { state } = this;
    state[e.target.name] = e.target.value;
    this.setState(state);
  }

  onChangeErrors(errors) {
    this.setState({ errors: errors });
  }

  onSubmit(e) {
    e.preventDefault();
    e.stopPropagation();

    this.setState({ loading: true });

    $.ajax({
      type: "POST",
      url: this.props.last_name_path,
      data: {
        last_name: this.state.last_name,
        confirmation_number: this.state.confirmation_number,
      },
    }).done((data) => {
      if (data.errors && data.errors.length) {
        this.setState({ loading: false, errors: data.errors });
      } else {
        window.location.href = data.redirect_to;
      }
    });
  }
}
